module.exports = __webpack_public_path__ + "static/media/jardines06M.d1635824.jpg";